import { OverlayTrigger, Popover, PopoverBody } from "react-bootstrap";
import SolarIcon from 'components/icons/SolarIcon';

const EOverlay = ({ text, iconClass = 'info-circle' }) => {
    const icon = <SolarIcon name={iconClass} className={text ? 'text-info' : 'text-muted'} />;

    if (!text) return icon;

    return (
        <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="left"
            overlay={
                <Popover className="popover-sm">
                    <PopoverBody>
                        <span dangerouslySetInnerHTML={{ __html: text.replaceAll('\n', '<BR>') }}></span>
                    </PopoverBody>
                </Popover>
            }
        >
            {icon}
        </OverlayTrigger>
    );
};

export default EOverlay;
